import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function ProjectCarousel() {
  const projectImages = [{
    src: 'https://cdn.magicpatterns.com/uploads/hK2QbL2UtC1NSJNdbeJf1x/Ca_1.webp',
    alt: 'Cartel Neon "Fiesta" Rosa'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/q9uWcSxs8yKG4SbCbKpAT4/ca_2.webp',
    alt: 'Cartel Neon "Buenas Vibras" con Rayo'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/qdDUpDEnE9PGCGBiNbNm5n/ca_3.webp',
    alt: 'Cartel Neon "Abierto" con Copa'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/aoaUimrMeskUzgcp3aAroK/ca_4.webp',
    alt: 'Cartel Neon "Tattoo Arte"'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/mVLWS1WG5ug5FJ8t1Fh8XE/ca_5.webp',
    alt: 'Cartel Neon "Sueña Grande"'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/9t8ra8XZD9cgtvLddTMEHC/ca_6.webp',
    alt: 'Cartel Neon "Parrilla & Relax"'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/6gJfCJJy5Ua1VenrDtpEn3/ca_7.webp',
    alt: 'Cartel Neon Charizard "Poder"'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/6fN8hmrhE8Fr2cJJA9LBoG/ca_8.webp',
    alt: 'Colección Neon Pokemon y Ofertas'
  }];
  const duplicatedImages = [...projectImages, ...projectImages];
  return <section className="py-20 px-4 relative z-10 bg-transparent overflow-hidden border-y border-white/5 pt-[0px] pb-[0px]" data-id="element-360">
      <style data-id="element-361">
        {`
          @keyframes scroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          .animate-scroll {
            animation: scroll 40s linear infinite;
          }
          .animate-scroll:hover {
            animation-play-state: paused;
          }
        `}
      </style>

      <div className="max-w-7xl mx-auto px-4 text-center mb-12" data-id="element-362">
        <h2 className="text-4xl md:text-6xl font-black text-white mb-6 tracking-tight" data-id="element-363">
          PROYECTOS QUE <span className="text-[#00f0ff]" data-id="element-364">VAS A LOGRAR</span>
        </h2>
        <p className="text-xl text-gray-400 max-w-2xl mx-auto font-medium" data-id="element-365">
          Desde carteles comerciales hasta piezas de decoración únicas. El
          límite es tu imaginación.
        </p>
      </div>

      <div className="relative w-full overflow-hidden py-10 pt-[45px] pb-[45px]" data-id="element-366">
        <div className="flex w-max animate-scroll gap-8 px-4" data-id="element-367">
          {duplicatedImages.map((image, index) => <div key={index} className="w-80 md:w-[450px] h-64 md:h-80 shrink-0 transition-all duration-500 hover:scale-105 hover:z-20 cursor-pointer group" data-id="element-368">
              <motion.div className="relative w-[300px] h-[200px] md:w-[450px] md:h-[320px] rounded-[2rem] overflow-hidden border border-white/10 shadow-2xl group-hover:border-[#00f0ff]/50 transition-all duration-500" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} data-id="element-369">
                <img src={image} alt={`Proyecto Neon Flex ${index + 1}`} width={450} height={320} loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" data-id="element-370" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#1a0b2e]/80 via-transparent to-transparent opacity-60" data-id="element-371" />
              </motion.div>
            </div>)}
        </div>
      </div>
    </section>;
}